// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-pre-roll-video-ad[data-v-46120c1a]{width:100%}", ""]);
// Exports
module.exports = exports;
